export function spacing(value) {
	return value * 0.8
}
